/**
 * Formula utilities shared between API and frontend
 */

/**
 * Remove string literals from formula text before bracket counting.
 * This prevents false negatives for formulas like: IF([status] = "[pending]", 1, 0)
 * where brackets inside strings should not be counted.
 *
 * @param text - Formula text to process
 * @returns Text with string literals replaced by empty quoted strings
 */
export function removeStringLiterals(text: string): string {
  return text
    .replace(/"(?:[^"\\]|\\.)*"/g, '""')  // Double-quoted strings
    .replace(/'(?:[^'\\]|\\.)*'/g, "''"); // Single-quoted strings
}
